import { AxiosInstance } from 'axios';

import { UserActivityColumns } from '../../enum/userActivityColumns.enum';
import { UserActivity } from '../../types';
import { PaginationRequest } from '../../types/PaginationRequest';
import { SortRequest } from '../../types/SortRequest';
import { ModalActivity } from '../../types/UserActivity';
import { userActivitiesEndpoints } from '../../utils/constants';
import { ActivitiesStatuses } from '../../utils/constants/ActivitiesStatuses';
import { axios } from '../axiosInstance';

import { CreateUserActivityInput, UserActivitiesResponse } from './UserActivitiesApi.schema';

class UserActivitiesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (userActivity: CreateUserActivityInput): Promise<UserActivity> => {
    return this.#requestInstance.post(userActivitiesEndpoints.userActivities, userActivity);
  };

  deleteUserActivity = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(userActivitiesEndpoints.getUserActivityById(id));
  };

  getUserActivityById = async (id: number): Promise<UserActivitiesResponse> => {
    return this.#requestInstance.get(userActivitiesEndpoints.getUserActivityById(id));
  };

  getUserActivitiesById = async (id: number, sortBy: string): Promise<UserActivitiesResponse> => {
    return this.#requestInstance.get(userActivitiesEndpoints.getUserActivitiesById(id, sortBy));
  };

  getAllUsersActivities = async (
    data?: PaginationRequest & SortRequest<UserActivityColumns> & { status: ActivitiesStatuses }
  ): Promise<UserActivitiesResponse> => {
    return this.#requestInstance.get(userActivitiesEndpoints.allUsersActivities, { params: data });
  };

  getPendingUsersActivities = async (limit: number): Promise<UserActivity[]> => {
    return this.#requestInstance.get(userActivitiesEndpoints.pendingUsersActivities, {
      params: { limit },
    });
  };

  updateUserActivity = async (activity: ModalActivity): Promise<UserActivity> => {
    return this.#requestInstance.patch(
      userActivitiesEndpoints.getUserActivityById(activity.id),
      activity
    );
  };

  updateUserActivityStatus = async ({
    id,
    status,
  }: {
    id: number;
    status: ActivitiesStatuses;
  }): Promise<UserActivity> => {
    return this.#requestInstance.patch(userActivitiesEndpoints.getUserActivityStatusById(id), {
      status,
    });
  };

  updateStatusForManyUserActivities = async ({
    ids,
    status,
  }: {
    ids: number[];
    status: ActivitiesStatuses;
  }): Promise<UserActivity[]> => {
    return this.#requestInstance.patch(userActivitiesEndpoints.getAllUsersActivity, {
      ids,
      status,
    });
  };
}

export const userActivitiesApi = new UserActivitiesApi(axios);
